<template>
  <div class="p-d-flex p-flex-column p-ai-center">
    <div class="p-mt-6 p-mb-5 p-mt-sm-3 p-mb-sm-3 text-title">
      Sélectionnez le vitrage concerné
    </div>

    <small
      v-if="
        intervention.typeOfIntervention.$invalid &&
        intervention.typeOfIntervention.$dirty
      "
      class="p-error"
    >
      Veuillez selectionner un type d'intervention
    </small>
    <div class="p-d-inline-flex p-jc-between p-my-2">
      <div class="interventionSelectorItem">
        <Image :src="useImage('visuel-parebrise.png')" alt="Pare-brise" v-on:click="selectInterventionType(1)" />
        <label for="parebrise" class="text-option" v-on:click="selectInterventionType(1)">Pare-brise</label>
        <RadioButton
          id="parebrise"
          name="typeOfIntervention"
          value="1"
          v-model="typeOfIntervention"
          class="p-my-3 p-my-sm-3"
        />
      </div>
      <div class="interventionSelectorItem">
        <Image :src="useImage('visuel-lunettearriere.png')" alt="Pare-brise" v-on:click="selectInterventionType(2)" />
        <label for="lunetteArriere" class="text-option" v-on:click="selectInterventionType(2)">Lunette arrière</label>
        <RadioButton
          id="lunetteArriere"
          name="typeOfIntervention"
          value="2"
          v-model="typeOfIntervention"
          class="p-my-3 p-my-sm-3"
        />
      </div>
      <div class="interventionSelectorItem">
        <Image :src="useImage('visuel-glaceslaterales.png')" alt="Pare-brise" v-on:click="selectInterventionType(3)" />
        <label for="vitresLaterales" class="text-option" v-on:click="selectInterventionType(3)">Vitres latérales</label>
        <RadioButton
          id="vitresLaterales"
          name="typeOfIntervention"
          value="3"
          v-model="typeOfIntervention"
          class="p-my-3 p-my-sm-3"
        />
      </div>
    </div>
    <Dropdown
      v-model="typeOfIntervention"
      :options="optionSelect"
      optionLabel="name"
      placeholder="Autres prestations"
      style="width: 40%; text-align: center"
      v-on:change="checkIfIsDescalingOrOptic"
    />
    <div class="p-mt-3 p-mb-5 text-legend" v-if="isDescaling">
      Les prestations de décalaminage et de rénovation optique ne sont
      disponibles que pour certains centres.
    </div>
    <div class="p-mt-3">
      <Button class="button-navigate" @click="onNext">Suivant</Button>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import { useMenuStore } from "../stores/menu";
import { useAppointmentStore } from "../stores/appointment";
import { required } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";

export default {
  name: "StepIntervention",
  setup(props, { emit }) {
    const menuStore = useMenuStore();
    const appointmentStore = useAppointmentStore();
    const typeOfIntervention = ref(null);
    const isDescaling = ref(false);

    const optionSelect = [
      { name: "Anti-brouillard", value: "4" },
      { name: "Décalaminage", value: "5" },
      { name: "Glace-retroviseur", value: "6" },
      { name: "Optiques / phares / feux", value: "7" },
      { name: "Toit panoramique", value: "8" },
      { name: "Traitement anti-pluie", value: "9" },
    ];

    const rules = {
      typeOfIntervention: { required },
    };

    const intervention = useVuelidate(rules, {
      typeOfIntervention,
    });
    const getNextUrl = () => {
      let nextUrl = null;
      switch (
        typeOfIntervention.value.value
          ? typeOfIntervention.value.value
          : typeOfIntervention.value
      ) {
        case "1":
          nextUrl = "/pare-brise";
          appointmentStore.appointment.glazing = "windshield";
          appointmentStore.appointment.other_service = null;
          break;
        case "2":
          nextUrl = "/mon-vehicule";
          appointmentStore.appointment.glazing = "rear_windshield";
          appointmentStore.appointment.other_service = null;
          break;
        case "3":
          nextUrl = "/cote-concerne";
          appointmentStore.appointment.glazing = "side_window";
          appointmentStore.appointment.other_service = null;
          break;
        case "4":
          nextUrl = "/cote-concerne";
          appointmentStore.appointment.glazing = null;
          appointmentStore.appointment.other_service = "anti-fog";
          break;
        case "5":
          nextUrl = "/decalaminage";
          appointmentStore.appointment.glazing = null;
          appointmentStore.appointment.other_service = "descaling";
          break;
        case "6":
          nextUrl = "/cote-concerne";
          appointmentStore.appointment.glazing = null;
          appointmentStore.appointment.other_service = "mirror_glass";
          break;
        case "7":
          nextUrl = "/cote-concerne";
          appointmentStore.appointment.glazing = null;
          appointmentStore.appointment.other_service = "optics_headlights_lights";
          break;
        case "8":
          nextUrl = "/mon-vehicule";
          appointmentStore.appointment.glazing = null;
          appointmentStore.appointment.other_service = "sunroof";
          break;
        case "9":
          nextUrl = "/mes-coordonnees";
          appointmentStore.appointment.glazing = null;
          appointmentStore.appointment.other_service = "anti-rain_treatment";
          break;
      }
      return nextUrl;
    };

    const onNext = () => {
      intervention.value.$touch();
      if (!intervention.value.$error) {
        const nextUrl = getNextUrl();
        const target = menuStore.getMenuItemWithUrl(nextUrl);
        target.parent = menuStore.currentMenuItem.to;

        let dataLayerToPush = {
          'event' : 'click',
          'pageName' : '/prise-de-rendez-vous/#/intervention',
          'eventCategory' : 'rdv',
          'eventAction' : 'next',
          'eventName' : nextUrl,
        };
        dataLayerToPush.intervention = appointmentStore.appointment.glazing || appointmentStore.appointment.other_service;
  
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(dataLayerToPush);

        emit("nextPage", target);
      }
    };

    const publicPath = process.env.BASE_URL;

    const useImage = (imageName) => {
      return require(`../assets/img/${imageName}`);
    };

    const checkIfIsDescalingOrOptic = () => {
      const selectedInterventionType = typeOfIntervention.value.value
          ? typeOfIntervention.value.value
          : typeOfIntervention.value

      isDescaling.value = selectedInterventionType === "5" || selectedInterventionType === "7"
    }

    const selectInterventionType = (interventionTypeId) => {
      typeOfIntervention.value = `${interventionTypeId}`
    }

    return {
      onNext,
      intervention,
      typeOfIntervention,
      optionSelect,
      publicPath,
      useImage,
      isDescaling,
      checkIfIsDescalingOrOptic,
      selectInterventionType
    };
  },
  async mounted() {
    const menuStore = useMenuStore();
    menuStore.reset();
  },
};
</script>

<style scoped>
.p-dropdown { /* force border of dropdown to show */
  border: 1px solid #a6a6a6 !important;
}
</style>

<style>
.interventionSelectorItem {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 2%;
}
@media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
  .text-option {
    height: 25px !important;
    text-align: center !important;
    line-height: 1em !important;
    font-size: .75rem;
  }
  .text-legend {
    line-height: 1rem;
    font-size: .875rem;
    margin: 1.5rem 0 .75rem 0 !important;
    text-align: center;
  }
  .p-dropdown {
    width: 80% !important;
  }
}
</style>
